import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectTasks = (state: any) => state.tasks || initialState;

// Loading
const makeSelectLoading =
    createSelector(
        selectTasks,
        tasksState => tasksState.loading
);

// Loading
const makeSelectLoadingButton =
    createSelector(
        selectTasks,
        tasksState => tasksState.loadingButton
);

// Loading Task Group
const makeSelectLoadingTaskGroup =
    createSelector(
        selectTasks,
        tasksState => tasksState.groupLoading
);

// Loading Tasks
const makeSelectLoadingTasks =
    createSelector(
        selectTasks,
        tasksState => tasksState.loadingTasks
);

// Users
const makeSelectUser =
    createSelector(
        selectTasks,
        tasksState => tasksState.users
);

// Tasks
const makeSelectTasks =
    createSelector(
        selectTasks,
        tasksState => tasksState.tasks
);

// Select Task
const makeSelectTask = 
    createSelector(
        selectTasks,
        tasksState => tasksState.task
);

// Select Task
const makeSelectTaskGroup = 
    createSelector(
        selectTasks,
        tasksState => tasksState.groupTask
);

// Select Task
const sidebarSelector = 
    createSelector(
        selectTasks,
        tasksState => tasksState.sidebar
);

const sidebarCreatePriceSelector = 
    createSelector(
        selectTasks,
        tasksState => tasksState.sidebarCreatePrice
);

const applicationsSelector = 
    createSelector(
        selectTasks,
        tasksState => tasksState.applications
);

const applicationsSelectorLoader = 
    createSelector(
        selectTasks,
        tasksState => tasksState.loaderApplications
);


const applicationsPageCountSelector = createSelector(
    selectTasks,
    tasksState => tasksState.pageCountApplicants,
)
  
const applicationsCurrentPageSelector = createSelector(
    selectTasks,
    tasksState => tasksState.currentPageApplicatants,
);

const jobCommentSelector = createSelector(
    selectTasks,
    tasksState => tasksState.jobComment,
);

const sidebarLoadingSelector = createSelector(
    selectTasks,
    tasksState => tasksState.sidebarLoadingSelector,
);

const pageCountSelector = createSelector(
    selectTasks,
    tasksState => tasksState.pageCount,
);

const currentPageSelector = createSelector(
    selectTasks,
    tasksState => tasksState.currentPage,
);


export {
    makeSelectLoading, 
    makeSelectLoadingTaskGroup, 
    makeSelectLoadingTasks, 
    makeSelectUser, 
    makeSelectTasks, 
    makeSelectTask, 
    makeSelectTaskGroup, 
    sidebarSelector,
    makeSelectLoadingButton,
    sidebarCreatePriceSelector,
    applicationsSelector,
    applicationsSelectorLoader,
    applicationsPageCountSelector,
    applicationsCurrentPageSelector,
    jobCommentSelector,
    sidebarLoadingSelector,
    pageCountSelector,
    currentPageSelector
}